import React from 'react'
import {ButtonProps, Button as ButtonUI} from 'wix-ui-tpa'
import classnames from 'classnames'
import {classes} from './button.st.css'

export const Button: React.FC<ButtonProps> = ({className, ...rest}) => (
  <ButtonUI {...rest} className={classnames(classes.root, className)} upgrade />
)
